import Vue from 'vue';
// import VueAnalytics from 'vue-analytics';
import VueSmoothScroll from 'vue2-smooth-scroll';
import VueRellax from 'vue-rellax';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

// Vue.use(VueAnalytics, {
//   id: 'UA-36995196-35',
//   router
// });

Vue.use(VueSmoothScroll, {
  updateHistory: false,
  offset: -60
});

Vue.use(VueRellax);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
